// @ts-nocheck
import { Handler } from "@insite/client-framework/HandlerCreator";
import { ProductRecommendationModel } from "@insite/client-framework/Services/ProductRecommendationsService";
import {
    chain,
    SendTracking,
} from "@insite/client-framework/Store/Components/ProductRecommendations/Handlers/PrepareTrack";
import { sendTracking } from "@store/Framework/Services/StoreProductRecommendationsService";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{ prepareTrackData: ProductRecommendationModel }>;

export const StoreSendTracking: HandlerType = () => {
    const json = encodeURIComponent(JSON.stringify(window.PeeriusCallbacks.track));
    sendTracking(json);
};
replaceInChain(chain, SendTracking, StoreSendTracking);
